export type LoaderType = LoaderTypeEnum.FILTER_PILL | LoaderTypeEnum.FILTER_INPUT;

export enum LoaderTypeEnum {
    FILTER_PILL = 'filter-pill',
    FILTER_INPUT = 'filter-input'
}
